module.exports = __webpack_public_path__ + "img/linkdin.da96e541.svg";